import { render } from "./ModalConnectWallet.vue?vue&type=template&id=56b5f827"
import script from "./ModalConnectWallet.vue?vue&type=script&lang=ts"
export * from "./ModalConnectWallet.vue?vue&type=script&lang=ts"
script.render = render

export default script